import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../config/cabinet-environment';

export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.startsWith('http://') || req.url.startsWith('https://')) {
    return next(req);
  }
  const apiReq = req.clone({ url: `${environment.API_ADDRESS}${req.url}` });
  return next(apiReq);
};
